import React from 'react';

interface Property {
  id: string;
  name: string;
}

interface Props {
  properties: Property[];
  value: string | null;
  onChange: (propertyId: string | null) => void;
}

export const PropertyFilter: React.FC<Props> = ({ properties, value, onChange }) => {
  return (
    <div className="flex items-center gap-2 py-3">
      <label htmlFor="cancellations-property-filter" className="text-14s font-medium text-gray-700">
        Property:
      </label>
      <select
        id="cancellations-property-filter"
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value === '' ? null : e.target.value)}
        className="h-9 min-w-[220px] rounded-md border border-solid border-gray-220 bg-white px-3 text-14s text-gray-900 focus:border-primary-500 focus:outline-none"
      >
        <option value="">All properties</option>
        {properties.map((p) => (
          <option key={p.id} value={p.id}>
            {p.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default PropertyFilter;
